'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var debug = require('debug');

var addLink = require('./add-link.js');

var dagPB = require('@ipld/dag-pb');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = debug__default["default"]('ipfs:mfs:utils:update-tree');
var defaultOptions = {
  shardSplitThreshold: 1000
};

function updateTree(_x, _x2, _x3) {
  return _updateTree.apply(this, arguments);
}

function _updateTree() {
  _updateTree = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, trail, options) {
    var index, child, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, block, node, _cid, name, result, _child, cid;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = Object.assign({}, defaultOptions, options);
            log('Trail', trail);
            trail = trail.slice().reverse();
            index = 0;
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 6;
            _iterator = _asyncIterator(context.repo.blocks.getMany(trail.map(function (node) {
              return node.cid;
            })));

          case 8:
            _context.next = 10;
            return _iterator.next();

          case 10:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 26;
              break;
            }

            block = _step.value;
            node = dagPB.decode(block);
            _cid = trail[index].cid;
            name = trail[index].name;
            index++;

            if (child) {
              _context.next = 19;
              break;
            }

            child = {
              cid: _cid,
              name: name,
              size: block.length
            };
            return _context.abrupt("continue", 23);

          case 19:
            _context.next = 21;
            return addLink.addLink(context, {
              parent: node,
              name: child.name,
              cid: child.cid,
              size: child.size,
              flush: options.flush,
              shardSplitThreshold: options.shardSplitThreshold,
              hashAlg: options.hashAlg,
              cidVersion: options.cidVersion
            });

          case 21:
            result = _context.sent;
            child = {
              cid: result.cid,
              name: name,
              size: result.size
            };

          case 23:
            _iteratorAbruptCompletion = false;
            _context.next = 8;
            break;

          case 26:
            _context.next = 32;
            break;

          case 28:
            _context.prev = 28;
            _context.t0 = _context["catch"](6);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 32:
            _context.prev = 32;
            _context.prev = 33;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 37;
              break;
            }

            _context.next = 37;
            return _iterator.return();

          case 37:
            _context.prev = 37;

            if (!_didIteratorError) {
              _context.next = 40;
              break;
            }

            throw _iteratorError;

          case 40:
            return _context.finish(37);

          case 41:
            return _context.finish(32);

          case 42:
            _child = child, cid = _child.cid;
            log("Final CID ".concat(cid));
            return _context.abrupt("return", cid);

          case 45:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 28, 32, 42], [33,, 37, 41]]);
  }));
  return _updateTree.apply(this, arguments);
}

exports.updateTree = updateTree;